
import { VBtn, VChip } from 'vuetify/lib'
import {mapGetters} from "vuex";
import VForm from '@/vuetify_custom/v-form'
import FileUploader from '@/views/components/file/uploader';
import EditAttachments from '@/views/components/file/edit_attachments_v1';
import RadioButtons from '@/vuetify_custom/v-form/components/Radio_Buttons.js'
import { hr_http } from '@/libs/util.js'
import VPopSelect from './v-pop-select-s.vue'
import { COURSE_WITHOUT_STOCK, CLOSE, EXPENSE} from '@/views/business/constants.js'
import RechargeTips from './RechargeTips.vue'
import { commonValidateRule, getVirtualContractType } from '../utils'
import { common_mixins, contract_types_mixins, stock_mixins} from './EditMixIns.jsx'
import {contract_i_e_types, contract_nature_list} from '../fields'
import { createlinkContractsParams, createVirtualStockParams, createStockParams } from '../utils'
import {getContractLegalAuditUsersApi, query_payee_company_account} from '../service'
import AccountNumberModal from '@/views/business/components/AccountNumberModal.jsx'
import styles from './index.module.less'
const commonValidateRuleGo = commonValidateRule('必选')
const commonValidateRuleGoOne = commonValidateRule('必填')
export default {
    mixins:[common_mixins, contract_types_mixins, stock_mixins],
    props: {
        defaultAccount: {
            type: Array
        },
        virtualContractChildSourceTotalPrice: {
            type: Number
        }
    },
    data() {
        return {
            auditUsers: []
        }
    },
    watch:{
        close_contract_total_invoice(new_val) {
            if (new_val) {
                this.validate()
            }
        }
    },
    computed: {
        ...mapGetters('async', [ 'team_company_mapping_hash']),
        is_financer() {
            return this.cur_customer.groups && this.cur_customer.groups.includes('GROUP_FIN');
        },
        contract_types_subclass_list() {
      
            if (!this.contract_types_all_hash || !this.contract_types_all_hash.i_e_m_hash) {
                return []
            }
            const type = `${this.params.contract_sz_type}-${this.params.contract_type_bread_id}`   
            return this.contract_types_all_hash.i_e_m_hash[type] || []
        },
        contract_types_broad_list() {
            if (!this.contract_types_all_hash || !this.contract_types_all_hash.main_type_hash) {
                return []
            }   
            const list = []
            Object.values(this.contract_types_all_hash.main_type_hash).forEach(arr => {
                const item = arr[0]
                list.push(item)
            })
            return list
           //  return this.contract_types_all_hash && 
        },
        contract_types_filter() {
            return this.contract_types
        },
        close_contract_total_invoice() {
        
            const is_no_invoices = this.params.contract_invoices && this.params.contract_invoices.length === 0
            const is_not_need_invoices = this.params.contract_sz_type === EXPENSE || this.params.contract_nature === CLOSE
            if (!is_not_need_invoices || is_no_invoices) {
                return true
            }
            const total = this.params.contract_invoices.reduce((total, item) => {
                return math.eval(`${total}+${item.tax}+${item.excluding_tax}`)
            }, 0)
            return Number(this.params.total_price) === (total.toNumber && total.toNumber())
        },
        fields() {
            const _this = this
            /* 合同小类 */
            let contract_types_subclass_list = []
            let shop = []
          
            if (this.params.team_id !== 0 && !this.params.team_id) {
                contract_types_subclass_list = this.contract_types_subclass_list
            } else {
                // 合同小类是否包含项目组
                contract_types_subclass_list = this.contract_types_subclass_list.map(item => {
                    item = {...item}
                    item.disabled = true
                    if (item.teams.some(item => item.id === this.params.team_id)) {
                        item.disabled = false
                    }
                    return item
                })
            }
            /* 供应商类型 */
            let supplier_type_arr = []
            if (Number(_this.params.payee_company_type) === 0) { // 供应商为公司
                supplier_type_arr = [
                    {
                        label: '个人证件号',
                        type: 'text_field',
                        key: 'payee_id_number',
                        cols: 3,
                        disabled: true,
                        // required: true,
                        // rules: [commonValidateRuleGo],
                    },
                ]
            }
              /* 合同总价与预估总价 */
              let total_price = []
            if (_this.params.contract_nature === 'close') {
                total_price = [{
                    label: '合同总价',
                    type: 'number_field',
                    key: 'total_price',
                    placeholder: '请输入合同的含税总价',
                    cols: 3,
                    required: true,
                    rules: [(val) => { 
                          if (isNaN(val)) {
                            return '必填'
                          }
                        return commonValidateRuleGo(val)}, () => {
                        return _this.close_contract_total_invoice || '发票信息栏中的不含税金额与税额之和必须等于合同总价'
                    },
                    (val) => {
                        if (_this.is_generate_from_contract_child) {
                            const total_price = this.virtualContractChildSourceTotalPrice
                            return Number(val) <= total_price || '子合同的合同总价不能超过主合同的合同总价'
                        }
                        return true
                    },  
                    this.productSumEqualtotal
                ],
                }]
            } else if (_this.params.contract_nature === 'open') {
                total_price = [{
                    label: '预估金额',
                    type: 'number_field',
                    key: 'total_price',
                    placeholder: '如果是开口合同，请输入预估金额',
                    cols: 4,
                    required: true,
                    disabled: _this.params.disableEditPrice,
                    rules: [(val) => { 
                        if (isNaN(val)) {
                          return '必填'
                        }
                      return commonValidateRuleGo(val)}, (val) => {
                        if (_this.is_generate_from_contract_child) {
                            const total_price = this.virtualContractChildSourceTotalPrice
                            return Number(val) <= total_price || '子合同的预估金额不能超过主合同的预估金额'
                        }
                        return true
                    }]
                }]
            }
            if (_this.params.virtual_contract_type === 2) {
                shop = [{ 
                    label: '店铺或账号信息',
                    key:'account_id',
                    type:'autocompletes_async_v1',
                    http:hr_http,
                    'item-value':'id',
                    api: this.$util.api.ams_account_search,
                    'item-text':'text_name',
                    initList: _this.defaultAccount,
                    cols: 6,
                    search_key: 'key',
                    out_params: {
                        page: 1,
                        size:10000
                    },
                    required: true,
                    rules: [val => {
                      return !!val || '必选'
                    }],
                    handle_data:({content}) => {
                      return content.map(item => ({
                        ...item,
                        text_name: `${item.accountName}-${item.platformName}`,
                      }))
                    },
                    change:(data, target) => {
                       _this.params.account_name = target.text_name
                    }
                  }]
            }
            return [
                {
                    label: '合同小类',
                    key:'contract_type_id',
                    type:'autocompletes',
                    'item-value':'id',
                    'item-text':'sub_type', // 'name',
                    items: contract_types_subclass_list,
                    cols: 3,
                    required: true,
                    disabled: this.is_generate_from_contract_child || !!this.params.ads_record_ids && !!this.params.ads_record_ids.length,
                    change:(val) => {
        
                        this.changeContractTypeId(val)
                    },
                    rules:[commonValidateRuleGo],
                },
                {
                    label: '合同大类',
                    key:'contract_type_bread_id',
                    type:'autocompletes',
                    'item-value':'main_type',
                    'item-text':'mian_type_name', // 'name',
                    disabled: true,
                    items: _this.contract_types_broad_list,
                    cols: 3,
                    rules:[commonValidateRuleGo],
                },
                {
                    label: '合同属性',
                    key:'contract_nature',
                    type:'autocompletes',
                    'item-value':'value',
                    'item-text':'label', // 'name',
                    disabled: true,
                    items: contract_nature_list,
                    cols: 3,
                    // rules:[commonValidateRuleGo],
                },
                {
                    label: '合同收支类型',
                    key:'contract_sz_type',
                    type:'autocompletes',
                    'item-value':'value',
                    'item-text':'label', // 'name',
                    disabled: true,
                    items: contract_i_e_types,
                    cols: 3,
                    rules:[commonValidateRuleGo],
                },
                {
                    label: '合同名称',
                    type: 'text_field',
                    key: 'name',
                    cols: 6,
                    required: true,
                    rules: [commonValidateRuleGoOne],
                },
                {
                    label: '团队',
                    type: 'team_select',
                    key: 'team_id',
                    required: true,
                    cols: 3,
                    rules: [commonValidateRuleGo],
                    change: (val) => {
                        // 如果是有合同生成子虚拟合同，暂时不要这个mapping关系
                        if (this.is_generate_from_contract_child) {
                            return
                        }
                        const team_company_mapping_hash = this.team_company_mapping_hash
                        if (!team_company_mapping_hash.companyTeamCorrespond(val, this.params.company_id)) {
                            this.params.company_id = null
                        }
                        // if (!this.params.contract_type_id) {
                        //     return 
                        // }
                      
                        let go = false
                        // 合同小类中的团队包含当前选择的团队
                        this.contract_types_subclass_list.forEach(item => {
                            if (item.id === this.params.contract_type_id) {
                                item.teams.forEach(team => {
                                    if (team.id === val) {
                                        go = true
                                    }
                                })
                            }
                        })
                        if (!go) {
                            _this.params.contract_type_id = null
                        }
                        if (!team_company_mapping_hash.companyTeamCorrespond(val, this.params.payee_company_id)) {
                            const company = team_company_mapping_hash.companyTeamCorrespondGetCompant(val)
                            this.params.company_id = company && company.company_id
                        }
                    }
                },
                {
                    label: '我方公司',
                    type: 'company_select',
                    key: 'company_id',
                    cols: 3,
                    required: true,
                    disabled: this.is_generate_from_contract_child,
                    rules: [commonValidateRuleGo],
                },
                {
                    label: '合同供应商类型',
                    type: 'select_field_v1',
                    key: 'payee_company_type',
                    disabled: this.is_generate_from_contract_child,
                    change: () => {
                        _this.changePayee()
                    },
                    items: [
                        {
                            title: '个人',
                            key: 0
                        },
                        {
                            title: '公司',
                            key: 1
                        },
                    ],
                    cols: 3,
                },
                // ...supplier_type_arr,
            
                {
                    label_0: '个人姓名',
                    label_1: '供应商名称',
                    key: 'contact',
                    cols: 3,
                    disabled: this.is_generate_from_contract_child,
                    rules: [commonValidateRuleGo],
                },  
                {
                  
                    label: '涉及多个供应商',
                    type: 'radio_buttons',
                    key: 'multi_payee',
                    required: true,
                    cols: 3,
                    row: true,
                    rules: [commonValidateRuleGo],
                    items: [
                        {
                            value: true,
                            key: true,
                            label: '是',
                        },
                        {
                            value: false,
                            key: false,
                            label: '否',
                        }
                    ]
                },
                ...supplier_type_arr,
                // {
                //     label: '供应商名称',
                //     key:'fill_customer_id',
                //     type:'autocompletes_async_v1',
                //     'item-value':'id',
                //     'item-text':'account',
                //     api: this.$util.api.query_payee_company_name,
                //     initList: this.apply_user_list,
                //     cols: 3,
                //     out_params: {
                //         type: 'company'
                //     },
                //     required: true,
                //     rules: [val => {
                //       return !!val || '供应商名称'
                //     }],
                //     handle_data:(data) => {
                //         return []
                //     },
                // },
                {
                    label: '开户行',
                    type: 'text_field',
                    key: 'payee_bank',
                    cols: 3,
                    disabled: true,
                },
                {
                    label: '银行账号',
                    type: 'text_field',
                    key: 'payee_bank_number',
                    cols: 3,
                    disabled: true,
                },
                {
                    label: '付款方式',
                    type: 'select_field_v1',
                    key: 'payee_bank_type',
                    cols: 3,
                    disabled: true,
                    items: [
                        {
                            title: '未设置',
                            key: -1
                        },
                        {
                            title: '银行卡',
                            key: 0
                        },
                        {
                            title: 'PayPal',
                            key: 10
                        },
                        {
                            title: '支付宝',
                            key: 20
                        },
                    ],
                    // rules: [commonValidateRuleGo],
                },
                ...total_price,
                // {
                //     type: 'empty'
                // },
                {
                    label: '合同起止时间',
                    key:'date_range',
                    start_key: 'contract_start',
                    end_key: 'contract_end',
                    type:'date_range',
                    required: true,
                    cols: 4,
                    prependIcon: '',
                    rules:[val => {
                        if (val && val.length < 2) {
                            return '需要选择时间段'
                        }
                        if (val && val.length === 2) {
                            return true
                        }
                        return '必选'
                    }],
                },
                ...shop,
                {
                    label: '法务审批人',
                    type: 'radio_buttons',
                    key: 'legal_audit_user_id',
                    cols: 8,
                    required: true,
                    items: this.auditUsers.map(item => {
                        return {
                            value: item.id,
                            key: item.id,
                            account: item.account,
                            disabled: !item.active,
                            scopedSlots: {
                                label:() => {
                                    return <span>
                                    <span class={styles['margin-r-f']}>
                                        {item.account}
                                    </span>
                                    {item.active && <VChip label class={styles['margin-r-f']} color="green" outlined>
                                        正在处理的数量：{item.pending}
                                    </VChip>}
                                    {item.active && <VChip label class={styles['margin-r-f']} color="green" outlined>
                                        平均处理时长(天)：{item.avg_time}
                                    </VChip>}
                                    {!item.active && <VChip label class={styles['margin-r-f']} color="orange" outlined>
                                        暂时无法提供服务
                                        </VChip>}
                                </span>
                                }
                            }
                        }
                    }),
                    rules: [commonValidateRuleGo],
                    change:(_, target) => {
                           this.params.legal_audit_user = target.account
                    }
                },
                {
                    label: '是否需充值预付',
                    type: 'radio_buttons',
                    key: 'is_recharge',
                    required: true,
                    row:true,
                   // row: true,
                    cols: 6,
                    items: [
                        {
                            value: true,
                            key: true,
                            label: '是',
                        },
                        {
                            value: false,
                            key: false,
                            label: '否',
                        }
                    ]
                },
                {
                    label: '是否框架协议',
                    type: 'radio_buttons',
                    key: 'is_framework',
                    required: true,
                    row:true,
                   // row: true,
                    cols: 6,
                    items: [
                        {
                            value: true,
                            key: true,
                            label: '是',
                        },
                        {
                            value: false,
                            key: false,
                            label: '否',
                        }
                    ],
                    scopedSlots: {
                        label:() => {
                            return <div><RechargeTips/><span style="color:red">*</span>是否是框架协议</div>
                        }
                    }
                },
                {
                    lable: '附件',
                    key:'files',
                },
                {
                    label: '备注',
                    key:'desc',
                    type: 'textareas_field'
                }
            ]
        }
    },
    created() {
        // 建立vuex的引用关系（没有实质用处）
        this.team_company_mapping_hash
    },
    methods: {
        // 合同总价与商品总价校验
        // this.params.contract_products
        productSumEqualtotal(val) {
            val = Number(val)
    
            const is_not_stock = !(this.params.contract_type_bread_id === COURSE_WITHOUT_STOCK && this.params.contract_nature === CLOSE)
          const contract_products = this.params.contract_products || []
          if (is_not_stock || !contract_products.length) {
            return true
          }
        
          let total = math.eval(0).toNumber()
          contract_products.forEach(i => {
            total = math.eval(`${total}+${i.unit_price || 0}*${i.qty || 0}`)
          })
         const max = math.eval(`${total}+0.1`).toNumber()
         const min = math.eval(`${total}-0.1`).toNumber()
          return max >= val && val >= min || '商品价格之和需等于合同总价'
        },
        _selectedTargetType() {
          setTimeout(() => {
           this.contract_types_subclass_list.forEach(i => {
               if (i.sub_type === '广告合同' && i.balance_type === 'expense' && i.main_type === 'stockless') {
                this.params.contract_type_id = i.id
                this.changeContractTypeId(i.id)
               }
           })
          }, 1000)
        },
        changeContractTypeId(val) {
            const _this = this
            let contract_types_subclass_list = []
     
          
            if (this.params.team_id !== 0 && !this.params.team_id) {
                contract_types_subclass_list = this.contract_types_subclass_list
            } else {
                // 合同小类是否包含项目组
                contract_types_subclass_list = this.contract_types_subclass_list.map(item => {
                    item = {...item}
                    item.disabled = true
                    if (item.teams.some(item => item.id === this.params.team_id)) {
                        item.disabled = false
                    }
                    return item
                })
            }
            contract_types_subclass_list.forEach(item => {
                if (item.id === val) {
                    this.params.contract_type = item
                    // 获取虚拟合同的类型
                    _this.params.virtual_contract_type = getVirtualContractType(item.sub_type, this.params.contract_type_bread_id === 'virtual')
                    _this.params.is_virtual_stock = item.sub_type.includes('虚拟组装订单')
                    _this.params.show_stock = ['stock_course', 'stock'].includes(item.relation_type)
                    if (_this.params.virtual_contract_type === 1) {
                        _this.params.link_contracts = []
                        _this.params.link_contracts.push(createlinkContractsParams())
                        _this.$emit('selectVirtual')
                    }
                    // 虚拟组装存货
                    if (_this.params.is_virtual_stock) {
                        _this.params.bill_type = 'OutSourcing'
                        if (!_this.params.contract_stocks || !_this.params.contract_stocks.length) {
                            _this.params.contract_stocks = [createStockParams()]
                        } else {
                            _this.params.contract_stocks = _this.params.contract_stocks.slice(0, 1)
                        }
                        if (!_this.params.contract_stock_parts || !_this.params.contract_stock_parts.length) {
                            _this.params.contract_stock_parts = [createVirtualStockParams()]
                        } else {
                            _this.getParentTotal()
                        }
                    }
                }
              
            })
        },
        changePayee(item = {}, c_item = {}) {
            this.params.payee_company_id = item.id
            this.params.payee_company_account_id = c_item.id
            this.params.payee_company = item.name
            this.params.payee_id_number = this.params.payee_company_type === 0 && item.id_number || null
            this.params.payee_bank = c_item.bank
            this.params.payee_bank_number = c_item.bank_number
            this.params.payee_bank_type = c_item.bank_type
        },
        getContractLegalAuditUsers() {
            if (this.auditUsers.length) {
                return 
            }
              // 获取 auditUsers
              getContractLegalAuditUsersApi().then(res => {
                this.auditUsers = res.users
            })
        },
        init() {
          this.getContractLegalAuditUsers()
          this.$nextTick(() => {
              if (this.params.payee_company) {
                this.$refs.contact && this.$refs.contact.search({
                    search: this.params.payee_company
                })
              }
          })
        }
    },
    render() {
        const _this = this
        return <div>
            <VForm
            ref="base"
            fields={_this.fields}
            v-model={_this.params}
            scopedSlots={{
                is_recharge:({field, value
                }) => {
                    return <div style="display:flex;align-items: center;">
                        <div>
                            <RadioButtons field={field} v-model={value}/>
                        </div>
                        <div>
                            <VBtn small color="primary" on={{
                                click:() => {
                                    this.$refs.account.edit()
                                }
                            }}>登记账号信息</VBtn>
                        </div>
                    </div>
                },
                files:() => {
                        return <div style="display:flex">
                    <p style="width:40px">
                        附件
                    </p>
                    <div style="flex:1">
                        <EditAttachments
                            files={_this.params.bfiles}
                            modelType="Contract"
                            modelId={_this.params.id}
                            />
                            <FileUploader 
                                validateFile={(file) => {
                                    const a = /\.[0-9a-zA-Z]+$/.test(file.name)
                                    if (!a) {
                                      this.$vModal.warning({
                                          title:'提示',
                                          content:'文件格式错误，无法解析。建议上传如下类型：.xlsx、.pdf等带有后缀的'
                                      })
                                    }
                                    return a
                                }}
                                on={{
                                    uploaded: (bfile) => {
                                        _this.params.bfiles.push(bfile)
                                    }
                                }}/>
                            <span class="color-error">为保证兼容性及文档可编辑性，请上传office系列的文档(Word, Excel, PPT)</span>
                    </div>
                </div>
                },
                contact:({field} = {}) => {
                    const type = _this.params.payee_company_type === 0 ? 'person' : 'company'
                    const label = _this.params.payee_company_type === 0 ? field.label_0 : field.label_1
                    // Util.api.query_payee_company_account
                    return <VPopSelect
                    ref="contact"
                    rules={field.rules}
                    required
                    v-model={_this.params.payee_company_id}
                    text = {label}
                    placeholder=''
                    disabled={field.disabled}
                    outParams={{
                        type
                    }}
                    url={query_payee_company_account}
                    handleSearch={({payee_companies = []} = {}) => {
                           return payee_companies
                    }}
                    contentHeigh={400}
                    on={{
                        change(_, item, c_item) {
                            _this.changePayee(item, c_item)
                            
                        }
                    }}
                    render = {
                        (h, item) => {
                            return <div>
                                <p class={styles['p-c']}>
                                    {item.name}
                                </p>
                            </div>
                        }
                    }
                    valueRender={(_, item) => {
                        if (!item) {
                            return ''
                        }
                        return item.name
                    }}
                />
                }
            }}
        />
        <AccountNumberModal ref="account" value={this.params}/>
        </div>
    }
}